import { Component, Input } from '@angular/core';
import { GlossaryTerm } from '../../models/glossary-term.model';

@Component({
  selector: 'app-glossary-term-row',
  standalone: true,
  templateUrl: './glossary-term-row.component.html',
  styleUrls: ['./glossary-term-row.component.scss'],
})
export class GlossaryTermRowComponent {
  @Input({ required: true }) term!: GlossaryTerm;
}
